import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { twitterXIcon } from '../utils/constants';
const CONTACT_US = 'https://ccsd.net/contactus/';
const YOUTUBE = 'https://www.youtube.com/ClarkCountySchoolDistrict';
const FACEBOOK = 'https://www.facebook.com/ClarkCountySchoolDistrict/';
const X_TWITTER = 'https://x.com/ClarkCountySch';
const INSTAGRAM = 'https://www.instagram.com/clarkcountysch/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" href={YOUTUBE} aria-label="YouTube">
            <FontAwesomeIcon icon={faYoutube} aria-hidden="true"/>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK} aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} aria-hidden="true"/>
          </a>
          <a className="footer-link x-icon" target="_blank" href={X_TWITTER} aria-label="X">
            <img src={twitterXIcon} alt="" width="16" height="16"/>
          </a>
          <a className="footer-link" target="_blank" href={INSTAGRAM} aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} aria-hidden="true"/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
